import React, { useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import { useLocation, useNavigate } from 'react-router-dom';
import { Box, TextField, Button, Typography, Checkbox, FormControlLabel } from '@mui/material';
const mockSupplier = {
  name: '测试供应商',
  email: 'supplier@example.com',
  contacts: [
    { name: '张三', email: 'zhangsan@example.com', phone: '13800000001' },
    { name: '李四', email: 'lisi@example.com', phone: '13800000002' },
    { name: '王五', email: 'wangwu@example.com', phone: '13800000003' },
  ]
};

const SendEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const supplier = location.state?.supplier;
  const [isSent, setIsSent] = useState(() => supplier?.emailStatus === "Sent");
  const factories = supplier?.factories || [];
  const contacts = supplier?.contacts || [];

  // 生成 HTML 格式的默认邮件内容
  const defaultEmailContent = `
<p>Hello,</p>
<p>Your certificates listed below will expire soon. Please update your certificates in time.</p>
${factories.length > 0 ? factories.map(factory => {
    const certs = factory.certificates?.length > 0
      ? `<ul>${factory.certificates.map(cert =>
        `<li>Certificate: <b>${cert.name || ''}</b>, Expiry Date: <b>${cert.expiryDate || ''}</b></li>`
      ).join('')}</ul>`
      : '<i>No certificates</i>';
    return `<div style="margin-bottom:12px;">
    <b>Factory:</b> ${factory.name || ''} (${factory.address || ''})<br/>
    ${certs}
  </div>`;
  }).join('') : '<i>No factories or certificates found.</i>'}
<p>Best regards,<br/>Bodco Team</p>
`;

  // const supplier = mockSupplier; // 用 mock 数据
  // const contacts = supplier?.contacts || [];
  // 默认全选所有联系人
  const [selectedContacts, setSelectedContacts] = useState(contacts.map((_, idx) => idx));
  const [emailContent, setEmailContent] = useState(defaultEmailContent);

  const handleContactChange = idx => {
    setSelectedContacts(prev =>
      prev.includes(idx)
        ? prev.filter(i => i !== idx)
        : [...prev, idx]
    );
  };

  const handleSend = async () => {
    // 这里调用实际发送邮件的接口
    const token = localStorage.getItem('token');
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5180/api';

    // 收集所有选中的联系人邮箱
    const toEmails = selectedContacts.map(idx => contacts[idx].email).join(';');
    const subject = `no-reply Email from Bodco`;
    const body = emailContent;
    const supplierId = supplier?.id;
    if (!toEmails || !body) {
      alert('The recipient and the email content cannot be empty.');
      return;
    }

    try {
      const res = await fetch(`${API_URL}/supplier/sendEmail`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          to: toEmails,
          subject,
          body,
          supplierId,
        }),
      });
      if (res.ok) {
        alert('The email was sent successfully.');
        navigate('/supplier');
      } else {
        const msg = await res.text();
        alert(`Email failed to send: ${msg}`);

      }
    } catch (err) {
      alert(`An error occurred while sending the email: ${err}`);
    }
    navigate('/supplier');
  };

  return (
    <Box sx={{ maxWidth: '100%', ml: 6, mr: 6, mt: 6, backgroundColor: '#fff', p: 3, borderRadius: 2, boxShadow: 2 }}>
      <Typography variant="h6" gutterBottom>Edit Email</Typography>
      {contacts.length > 0 ? (
        contacts.map((contact, idx) => (
          <FormControlLabel
            key={contact.email || idx}
            control={
              <Checkbox
                checked={selectedContacts.includes(idx)}
                onChange={() => handleContactChange(idx)}
              />
            }
            label={`Send to contacts: ${contact.name || 'unknown'} (${contact.email || 'no recipient email'})`}
          />
        ))
      ) : (
        <Typography color="text.secondary">no recipient email</Typography>
      )}

      <ReactQuill
        theme="snow"
        value={emailContent}
        onChange={setEmailContent}
        style={{ margin: '16px 0', minHeight: 200 }}
      />
      <Button variant="contained" onClick={handleSend} >Send</Button>
      <Button sx={{ ml: 2 }} onClick={() => navigate("/supplier")}>Cancel</Button>
    </Box>
  );
};

export default SendEmail;